export class AppError {
  message: string;
  status: number | null;
  url: string;

  constructor(message: string, status: number = null, url: string = null) {
    this.message = message;
    this.status = status;
    this.url = url;
  }

  formatErrorForToast(): string {
    const msg =
      this.status === null
        ? this.message
        : `${this.status} \n\n${this.message}`;

    if (this.status === 429) {
      return this.url === null ? msg : `${msg}\n\nURL: ${this.url}`;
    }

    return msg;
  }
}
